export default "__VITE_ASSET__Cm0bf3Xi__"